import { render } from "./CategoryCard.vue?vue&type=template&id=62869730&scoped=true"
import script from "./CategoryCard.vue?vue&type=script&lang=js"
export * from "./CategoryCard.vue?vue&type=script&lang=js"

import "./CategoryCard.vue?vue&type=style&index=0&id=62869730&scoped=true&lang=scss"

import exportComponent from "/home/forge/s.thebuyhive.com/expertsourcing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62869730"]])

export default __exports__